import { Box, Stack, Typography } from '@mui/material';
import { UnwindOrderState } from '../../hooks/useUnwindingSocket';
import { ExecutionLogTable } from './ExecutionLogTable';

interface RuleDetailPanelProps {
  ruleId: string;
  liveState?: UnwindOrderState;
}

export const RuleDetailPanel = ({ ruleId, liveState }: RuleDetailPanelProps) => {
  return (
    <Box sx={{ px: 2, py: 1 }}>
      {/* Live order details */}
      {liveState && liveState.state !== 'idle' && (
        <Box sx={{ mb: 1.5 }}>
          <Typography
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              color: 'grey.400',
              mb: 0.5
            }}
          >
            Live Order
          </Typography>
          <Stack direction="row" spacing={2} sx={{ fontSize: '0.75rem' }}>
            <Typography sx={{ fontSize: '0.75rem', color: 'grey.300' }}>
              Platform: <b>{liveState.makerPlatform}</b>
            </Typography>
            {liveState.makerPrice != null && (
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.300' }}>
                Price: <b>{liveState.makerPrice}</b>
              </Typography>
            )}
            {liveState.makerFilledQty > 0 && (
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.300' }}>
                Filled: <b>{liveState.makerFilledQty}</b> @ {liveState.makerFilledPrice}
              </Typography>
            )}
            {liveState.counterOrderId && (
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.300' }}>
                Counter: <b>{liveState.counterOrderId.slice(0, 8)}...</b>
                {liveState.counterFilledQty > 0 && ` (filled: ${liveState.counterFilledQty})`}
              </Typography>
            )}
            {liveState.errorMessage && (
              <Typography sx={{ fontSize: '0.75rem', color: 'error.main' }}>
                {liveState.errorMessage}
              </Typography>
            )}
          </Stack>
        </Box>
      )}
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: 600,
          color: 'grey.400',
          mb: 0.5
        }}
      >
        Execution History
      </Typography>
      <ExecutionLogTable ruleId={ruleId} />
    </Box>
  );
};
